import { status } from './statusTypes'
import { failure } from './failureTypes'

export const notFoundPath = '/NOT_FOUND_PATH'
export const basePath = '/fcx/index.html'

export {
  status,
  failure
}